<template>
  <div class="reportList">
    <div class="filtrateBox">
      <div class="List">
        <div
          :class="['grade', yearIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': yearList.length + 3 - index,
            transform: 'translateX(' + index * 34 * -1 + 'px)',
          }"
          v-for="(item, index) in yearList"
          :key="index"
          @click="yearSelest(index)"
        >
          {{ item.Name }}
        </div>
      </div>
      <div class="List">
        <div
          :class="['grade', CycleIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': CycleList.length + 3 - index,
            transform: 'translateX(' + index * 34 * -1 + 'px)',
          }"
          v-for="(item, index) in CycleList"
          :key="index"
          @click="CycleSelect(index)"
        >
          {{ item.Name }}
        </div>
      </div>
      <div class="List">
        <div
          :class="['grade', classIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': classList.length + 3 - index,
            transform: 'translateX(' + index * 34 * -1 + 'px)',
          }"
          v-for="(item, index) in classList"
          :key="index"
          @click="ClassSlect(index)"
        >
          {{ item.Name }}
        </div>
      </div>
      <el-select v-model="ProceTitle" placeholder="请选择过程评价">
        <el-option
          v-for="item in ProceTitleList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Name"
        >
        </el-option>
      </el-select>
      <div class="btnList">
        <el-input
          size="mini"
          placeholder="请输入"
          style="width: 300px"
          v-model="studentName"
        />
        <el-button size="mini" @click="WebGrowStudentList" type="primary"
          >查询</el-button
        >
        <!-- <el-button
          size="mini"
          type="primary"
          @click="batchCreateFn"
          v-if="userInfo.UserIdentity.indexOf('2') != -1"
          >批量创建</el-button
        > -->
      </div>
    </div>
    <div class="reportListBox">
      <el-button
        size="mini"
        style="
          border-color: #5474e6;
          background: #5474e6;
          align-self: flex-start;
          margin-bottom: 15px;
        "
        type="primary"
        class="btn"
        @click="autoReport"
        >生成报告</el-button
      >
      <el-button
        size="mini"
        style="
          border-color: #5474e6;
          background: #5474e6;
          align-self: flex-start;
          margin-bottom: 15px;
        "
        type="primary"
        class="btn"
        @click="downReport"
        >下载生成的报告</el-button
      >
      <el-table
        :header-cell-style="{
          background: '#F2F5FF',
        }"
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="StudyYearName" label="学届" width="180">
        </el-table-column>
        <el-table-column prop="GradeName" label="年级" width="180">
        </el-table-column>
        <el-table-column prop="ClassName" label="班级"> </el-table-column>
        <el-table-column prop="StudentName" label="姓名"> </el-table-column>
        <el-table-column prop="Status" label="性别">
          <template slot-scope="scope">
            <el-tag type="success">{{
              scope.row.Sex == 0 ? "女" : "男"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <!-- #999999 v-if="scope.row.Status == 1"-->
            <el-button
              size="mini"
              style="color: #5474e6"
              type="text"
              @click="lookReport(scope.$index, scope.row)"
              >查看报告</el-button
            >
            <!-- <el-button
              v-if="userInfo.UserIdentity.indexOf('2') != -1"
              size="mini"
              style="color: #5474e6"
              type="text"
              @click="Record(scope.row)"
              >去记录</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>

      <!-- <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="PageSizeChange"
          :current-page="PageIndex"
          :page-sizes="[10, 20, 30, 40, 60, 80, 100]"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dataCount"
          style="text-align: center;padding:20px; 0 0 0"
        >
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>
  
  <script>
import {
  WebGrowStudentList,
  getAcademicSelect,
  GetTenantTempByPage,
  GetTenantTempDetailInfo,
  GetStudentByPage,
  GoTenantTempDetailOneInfoByImgTextRecord,
  SaveBatchDetailInfo,
  GetOpenCycleInfoSelectResult,
  GetClassSelect,
  DownMyZip,
  GetProceTitleList,
  GetStudentListByProceDown,
} from "@/api/api";
export default {
  data() {
    return {
      addDialogVisible: false,
      recordDialogVisible: false,
      reportName: "",
      scopeValue: "",
      scopeList: [],
      typeNum: 0,
      tableData: [],
      dataCount: 0,
      studentName: "", //学生姓名
      status: "", //状态
      btn_study_cycle_id: null, //学期Id
      PageIndex: 1, // 分页
      PageSize: 20,
      name: "", // 成长足迹名称
      statusArr: [
        {
          Name: "未完成",
          Id: 2,
        },
        {
          Name: "已完成",
          Id: 1,
        },
      ],
      templateGrowingList: [], //成长足迹列表
      templateGrowingChildList: [], //成长足迹子模块列表
      studentList: [], //学生列表
      batchrRecordFrom: {
        tempId: "",
        tempDetailId: "",
        answer: "",
        teacherId: 0,
        customerIds: [],
        type: 1,
        isWeb: 1,
      },
      userInfo: {},
      getStudentFrom: {
        GradeName: "",
        ClassName: "",
      },
      recordInfo: {
        Title: "",
        TypeNum: 0,
      },
      editFrom: {
        Content: "",
        BackCoverImg: "",
        Answer: "",
        PlateId: "",
      }, //去记录参数
      isKindergarten: false,
      GradeId: "", //年级id
      multipleSelection: [],
      ProceTitleList: [],
      ProceTitle: "",
      yearList: [],
      yearIndex: 0,
      GradeList: [],
      GradeIndex: 0,
      classList: [],
      classIndex: 0,
      CycleList: [],
      CycleIndex: 0,
    };
  },

  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    //console.log(!this.userInfo.UserIdentity.includes("1"));
    let UserIdentityArr = this.userInfo.UserIdentity.split(";");
    let isKindergarten = UserIdentityArr.find((item) => {
      return item == 1;
    });
    if (isKindergarten) {
      this.isKindergarten = true;
    } else {
      this.isKindergarten = false;
    }
    // this.WebGrowStudentList();
    this.getAcademicSelect();
    this.batchrRecordFrom.teacherId = this.userInfo.uID;
  },
  methods: {
    // 获取学界
    async getAcademicSelect() {
      let UserIdentityArr = this.userInfo.UserIdentity.split(";");
      let isKindergarten = UserIdentityArr.find((item) => {
        return item == 1;
      });
      let xhr = await getAcademicSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        Type: isKindergarten ? 3 : 2, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.yearList = xhr.data.response;
        this.yearIndex = 0;
        if (this.yearList.length != 0) {
          //   this.GetGradeSelect();
          this.GetOpenCycleInfoSelectResult();
        }
      } else {
        this.yearList = [];
      }
    },

    // 获取班级列表
    async GetClassSelect() {
      let xhr = await GetClassSelect({
        StudyYearId: this.yearList[this.yearIndex].Id,
        SchoolId: this.userInfo.SchoolId,
        GradeId: this.CycleList[this.CycleIndex].GradeId, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.classList = xhr.data.response;
        this.classIndex = 0;
        this.WebGrowStudentList();
      } else {
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },

    // 获取年级列表
    async GetGradeSelect() {
      let xhr = await GetGradeList({
        SchoolType: this.userInfo.SchoolType,
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: this.yearList[this.yearIndex].Id,
        Uid: this.userInfo.uID,
      });
      if (xhr.data.success) {
        this.GradeList = xhr.data.response;
        this.GradeIndex = 0;
        if (this.GradeList.length != 0) {
          this.GetClassSelect();
        }
      } else {
        this.GradeList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
    // 获取周期
    async GetOpenCycleInfoSelectResult() {
      let xhr = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.yearList[this.yearIndex].Id,
      });
      if (xhr.data.success) {
        this.CycleList = xhr.data.response;
        this.CycleIndex = 0;
        if (this.CycleList.length) {
          await this.GetClassSelect();
        }
      } else {
        this.CycleList = [];
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
    yearSelest(index) {
      this.yearIndex = index;
      this.GetOpenCycleInfoSelectResult();
    },
    GradeSelect(index) {
      this.GradeIndex = index;
      this.GetClassSelect();
    },

    ClassSlect(index) {
      this.classIndex = index;
      this.WebGrowStudentList();
    },

    CycleSelect(index) {
      this.CycleIndex = index;
      this.GetClassSelect();
    },
    onClickProce(e) {
      console.log(e);
    },
    async GetProceTitleList() {
      let res = await GetProceTitleList({
        StudentName: this.studentName ? this.studentName : undefined,
        StudyYearId: this.yearList[this.yearIndex].Id,
        CycleId: this.CycleList[this.CycleIndex].Id,
        ClassId: this.classList[this.classIndex].Id,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
      });
      if (res.data.success) {
        this.ProceTitleList = res.data.response;
        // this.ProceTitle = res.data.response[0].Id;
        console.log(this.ProceTitleList, "this.ProceTitleList");
      }
    },
    autoReport() {
      let arr = [];
      console.log(this.multipleSelection, "aaa");
      //
      //  //console.log(a, "this.multipleSelection");
      if (this.multipleSelection.length > 0) {
        //console.log(arr, "arr");
        for (let index = 0; index < this.multipleSelection.length; index++) {
          const element = this.multipleSelection[index];
          const href = this.$router.resolve({
            path: "/all_result",
            query: {
              Ids: JSON.stringify(element.Ids),
              Type: 1,
              studentId: element.StudentId,
              StudentName: element.StudentName,
              Num: index,
            },
          });
          window.open(href.href, "_blank");
        }
      } else {
        this.$message.warning("请选择最少完成1个的过程评价进行生成");
      }
    },
    downReport() {
      DownMyZip({ Id: 0, Type: "过程评价" }).then((res) => {
        //console.log(res);
        if (res.data.success) {
          window.open("http://pdffile.mushroomisland.cn" + res.data.response);
        } else {
          this.$message({
            type: "error",
            message: "失败",
            offset: 110,
          });
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //console.log(val);
    },
    ClearFrom() {
      this.studyYearId = "";
      this.yearValue = "";
      this.classId = "";
      this.status = "";
      this.btn_study_cycle_id = 0;
      this.studentName = "";
      this.reportName = "";
      this.btn_study_cycle = [];
    },
    lookReport(index, item) {
      const href = this.$router.resolve({
        path: "/all_result",
        query: {
          Ids: JSON.stringify(item.Ids),
          Type: 0,
          studentId: item.StudentId,
          StudentName: item.StudentName,
        },
      });
      window.open(href.href, "_blank");
    },
    downlookReport(index, item) {
      let info = {
        TeacherId: item.TecherId,
        TempId: item.TempId,
        CustomerId: item.StudentId,
        TempType: item.TempType,
        CycleName: item.CycleName,
        StudentName: item.StudentName,
      };
      const href = this.$router.resolve({
        path: "/growingFootprintReport",
        query: {
          info: escape(JSON.stringify(info)),
          Type: 1,
        },
      });
      window.open(href.href, "_blank");
    },
    async addFn() {
      if (!this.batchrRecordFrom.answer) {
        this.$message.warning("请填写成长足迹记录");
        return;
      }
      let xhr = await SaveBatchDetailInfo(this.batchrRecordFrom);
      if (xhr.data.success) {
        this.editFrom.Answer = "";
        this.recordDialogVisible = false;
        // this.WriteTempDetailList();
        this.$message.success("保存成功");
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    record_plate_change(e) {
      this.batchrRecordFrom.answer = JSON.stringify(e);
    },

    async GoTenantTempDetailOneInfoByImgTextRecord() {
      if (!this.batchrRecordFrom.teacherId) {
        this.$message.warning("请选择模板");
        return;
      }
      if (!this.batchrRecordFrom.teacherId) {
        this.$message.warning("请选择主题");
        return;
      }
      if (this.batchrRecordFrom.customerIds.length == 0) {
        this.$message.warning("请选择学生");
        return;
      }
      this.addDialogVisible = false;
      this.recordDialogVisible = true;
      let xhr = await GoTenantTempDetailOneInfoByImgTextRecord({
        Id: this.batchrRecordFrom.tempDetailId,
        StudentId: this.batchrRecordFrom.customerIds[0],
      });
      if (xhr.data.success) {
        this.editFrom.Content = xhr.data.response.Content;
        this.editFrom.BackCoverImg = xhr.data.response.BackCoverImg;
        // this.editFrom.Answer = xhr.data.response.Answer;
        this.editFrom.Answer = "";
        this.editFrom.PlateId = xhr.data.response.PlateId;
      } else {
        this.editFrom = {
          Content: "",
          BackCoverImg: "",
          Answer: "",
          PlateId: "",
        };
        this.$message.error(xhr.data.msg);
      }
    },
    templateGrowingChange(value) {
      this.recordInfo = this.templateGrowingChildList.find((item) => {
        return item.Id == value;
      });
      this.batchrRecordFrom.type = this.recordInfo.TypeNum;
    },
    clearAddFromRecord() {
      this.clearAddFrom();
    },
    clearStudentAll() {
      this.batchrRecordFrom.customerIds = [];
    },
    checkStudentAll() {
      this.batchrRecordFrom.customerIds = [];
      this.studentList.forEach((item) => {
        this.batchrRecordFrom.customerIds.push(item.Id);
      });
    },
    tempChange(value) {
      let obj = this.templateGrowingList.find((item) => {
        return item.Id == value;
      });
      //console.log(obj, "ssssssss");
      if (obj) {
        this.getStudentFrom.GradeName = obj.GradeName;
        this.getStudentFrom.ClassName = obj.ClassName;
        this.getStudentList();
        this.getTemplateGrowingChildList();
      }
    },
    clearAddFrom() {
      this.batchrRecordFrom = {
        tempId: "",
        tempDetailId: "",
        answer: "",
        teacherId: "",
        customerIds: [],
        type: 1,
        isWeb: 1,
      };
      this.batchrRecordFrom.teacherId = this.userInfo.uID;
    },
    // 获取学生列表
    async getStudentList() {
      //console.log(this.userInfo, " this.userInfo");
      let xhr = await GetStudentByPage({
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: this.studyYearId ? this.studyYearId : 0,
        GradeId: this.GradeId,
        ClassId: this.classId,
        PageIndex: 1,
        PageSize: 100000,
        Uid: this.userInfo.uID,
      });
      if (xhr.data.success) {
        this.studentList = xhr.data.response.data;
      } else {
        this.studentList = [];
      }
    },

    // 获取成长足迹列表
    async getTempList() {
      let obj = this.classList.find((item) => {
        return item.Id == this.classId;
      });
      //console.log(obj, "obj");
      let params = {
        PageIndex: this.PageIndex,
        PageSize: 100,
        Status: 1,
        StudyYearId: this.studyYearId ? this.studyYearId : 0,
        Year: this.yearValue ? this.yearValue : undefined,
        classId: this.classId ? this.classId : undefined,
        ClassName: obj ? obj.ClassName : undefined,
        GradeName: obj ? obj.GradeName : undefined,
        CycleId:
          this.btn_study_cycle.length != 0
            ? this.btn_study_cycle[this.btn_study_cycle_id].Id
            : 0,

        GradeId: this.GradeId == "" ? 0 : this.GradeId,
      };

      let xhr = await GetTenantTempByPage(params);
      if (xhr.data.success) {
        this.templateGrowingList = xhr.data.response.data;

        this.batchrRecordFrom.tempId = xhr.data.response.data[0].Id;
        this.templateGrowingChildList = [];
        this.studentList = [];
        this.getStudentList();
        this.getTemplateGrowingChildList();
      } else {
        this.templateGrowingList = [];
      }
    },
    /**
     *获取子模板
     */

    async getTemplateGrowingChildList() {
      let xhr = await GetTenantTempDetailInfo({
        id: this.batchrRecordFrom.tempId,
      });
      if (xhr.data.success) {
        xhr.data.response = xhr.data.response.sort(function (a, b) {
          return a.OrderSort - b.OrderSort;
        });
        this.templateGrowingChildList = xhr.data.response.filter((item) => {
          return (
            (item.TypeNum == 6 || item.TypeNum == 9 || item.TypeNum == 10) &&
            item.Status == 1
          );
        });

        if (this.templateGrowingChildList.length > 0) {
          this.recordInfo = this.templateGrowingChildList[0];
          this.batchrRecordFrom.tempDetailId =
            this.templateGrowingChildList[0].Id;
        }
        this.batchrRecordFrom.type = this.recordInfo.TypeNum;
      } else {
        this.templateGrowingChildList = [];
      }
    },

    batchrRecordAffirm() {},
    batchrRecord() {
      this.addDialogVisible = true;
    },
    // 去记录
    Record(item) {
      //console.log(item);
      let info = {
        CustomerId: item.StudentId,
        StudentName: item.StudentName,
        TeacherId: item.TecherId,
        TempId: item.TempId,
        CycleId: item.CycleId,
        GradeName: item.GradeName,
        ClassName: item.ClassName,
        StudyYearId: item.StudyYearId,
        TempType: item.TempType,
        CycleName: item.CycleName,
      };
      this.$router.push({
        path: "/record",
        query: { info: escape(JSON.stringify(info)) },
      });
    },
    // 获取成长足迹列表
    async WebGrowStudentList() {
      await this.GetProceTitleList();
      await this.GetStudentListByProceDown();
    },
    async GetStudentListByProceDown() {
      let res = await GetStudentListByProceDown({
        StudentName: this.studentName,
        StudyYearId: this.yearList[this.yearIndex].Id,
        CycleId: this.CycleList[this.CycleIndex].Id,
        ClassId: this.classList[this.classIndex].Id,
        IsBaby: this.CycleList[this.CycleIndex].IsBaby,
        BabyLevel: this.CycleList[this.CycleIndex].BabyLevel,
        Title: this.ProceTitle,
      });
      if (res.data.success) {
        this.tableData = res.data.response;
      } else {
        this.tableData = [];
      }
    },
  },
};
</script>
  
  <style lang="less" scoped>
.inputBox {
  display: flex;
  margin-bottom: 15px;
  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    // width: 90px;
    padding-left: 30px;
    text-align: right;
  }
}

.filtrate {
  display: flex;

  background-color: #fff;
  min-height: 137px;
  margin-bottom: 10px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
  box-sizing: border-box;
  .filtrateSelect {
    display: flex;
    flex-wrap: wrap;

    flex: 1;
  }
}

.reportListBox {
  background-color: #fff;
  min-height: 300px;
  padding: 17px 22px;
  box-sizing: border-box;
}
.pagination {
  margin-top: 30px;
}
/* 15738996700 */
.List {
  height: 30px;
  margin-bottom: 10px;
  .grade {
    position: relative;
    display: inline-block;
    min-width: 83px;
    height: 30px;
    border: 1px solid #cdcdcd;
    background: #e5ebff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding-right: 14px;
    padding-left: 34px;
    box-sizing: border-box;
    line-height: 30px;
    color: #333333;
    cursor: pointer;
  }
  .grade:nth-child(1) {
    padding-left: 14px;
  }
  .gradeActive {
    color: #ffffff;
    background: #5474e6;
    border: 1px solid #5474e6;
  }
}
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.echartBox {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  .studentListBox {
    width: 200px;
    height: 400px;
    border: #ccc 1px solid;
    border-radius: 20px;
    overflow: hidden;
    .studentList {
      width: 220px;
      height: 420px;
      padding: 10px;
      overflow: scroll;
      box-sizing: border-box;
      .studentItem {
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
      }
      .studentItem div:nth-child(1) {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
}
.filtrateBox {
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 10px;
}
.contentBox {
  margin-top: 20px;
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
}
.List {
  display: flex;
  div {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.btnList {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  div {
    margin-right: 10px;
  }
}
.elPopoverTable {
  cursor: pointer;
}

.item-box {
  width: 129px;
  height: 150px;
  background: #f2f5ff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 10px;
  justify-content: center;
  .item-name {
    font-size: 16px;
    font-weight: 600;
    color: #033333;
    padding: 10px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
}
.studentBox {
  flex-wrap: wrap;
  display: flex;
  padding: 20px;
  margin-top: 10px;
  background-color: #ffffff;
}
.moduleItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 90px;
  border-bottom: 1px #dcf0ff dashed;
  cursor: move;
  height: 40px;
}
.moduleList > div:nth-child(1) {
  display: flex;
  justify-content: space-between;
}
</style>